<template>
  <div :class="$style.app">
    <GameContainer
      v-on="$listeners"
      v-bind="$attrs"
      gameComponent="RiddleGame"
      :fixedAspectRatio="false"
      hasTimer
      reloadOnRetry
    />
  </div>
</template>

<script>
import GameContainer from '@/components/GameContainer'

export default {
  components: {
    GameContainer,
  },
}
</script>

<style module lang="scss">
.app {
  :global {
    @import '~@/style/global';
    @include root-styles;
  }
}
</style>
